import React from 'react';
import { useSelector } from 'react-redux';
import CarrierTile from './carriermasters-tile';
import CarrierTable from './carriermasters-table';
import CarrierSearch from './carriermasters-search';
import { selectTileView } from './store/selectors';

const CarrierContent = () => {
  const showTileView = useSelector(selectTileView);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <CarrierSearch />
        </div>
        {!showTileView ? <CarrierTable /> : <CarrierTile />}
      </div>
    </div>
  );
};

export default CarrierContent;

